import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { PeopleService, Person, SearchBox } from "../../common";

import { ModalDirective } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";

@Component({
  selector: "people-picker",
  templateUrl: "./people-picker.html",
  standalone: false,
})
export class PeoplePicker implements OnInit, OnDestroy {
  @Input() selectedPeople: Person[] = [];
  @Output() personSelected: EventEmitter<Person> = new EventEmitter<Person>();

  errorMsg: string;
  searchCriteria: string;
  people: Person[];
  memberType: number = 1;

  @ViewChild("pickerDlg") pickerDlg: ModalDirective;
  @ViewChild("box") searchBox: SearchBox;
  pickerDlgShownSub: any;

  constructor(public peopleService: PeopleService, public router: Router) {}

  ngOnInit() {
    this.pickerDlgShownSub = this.pickerDlg?.onShow.subscribe(() => {
      if (!this.searchCriteria) {
        setTimeout(() => this.searchBox.focus(), 550);
      }
    });
  }

  isSecurity() {
    return this.router.url.includes("/security");
  }

  ngOnDestroy() {
    this.pickerDlgShownSub?.unsubscribe();
  }

  updateSearchCriteria(criteria: string) {
    this.searchCriteria = criteria;
    this.loadItems();
  }

  memberTypeChanged(type: number) {
    this.memberType = type;
    this.loadItems();
  }

  pageChanged(pageNumber: number) {
    this.loadItems(pageNumber);
  }

  loadItems(pageIndex?: number) {
    this.errorMsg = null;
    this.people = null;

    if (this.searchCriteria) {
      console.log(this.memberType);
      this.peopleService
        .filterBy({
          search: this.searchCriteria,
          memberType: this.memberType,
          pageIndex,
        })
        .subscribe(
          (people) => {
            this.people = people;
          },
          (error) => (this.errorMsg = error)
        );
    }
  }
  filterPeople(filterType: string): Person[] {
    return this.people?.filter((i) => i.type === filterType);
  }
  select(person: Person) {
    if (!this.isSelected(person)) {
      this.personSelected.emit(person);
      this.hide();
    }
  }

  isSelected(person: Person) {
    return this.selectedPeople.find((item) => item.id === person.id) != null;
  }

  show(criteria?: string) {
    this.updateSearchCriteria(criteria);
    this.pickerDlg.show();
  }

  hide() {
    this.pickerDlg.hide();
  }
}
